<template>
	<section class="section organisation-collections">
		<div class="container mx-auto px-4 flex flex-wrap items-center">
			<h3 class="section-title">Browse organisation collections</h3>

			<div :class="['organisation-collection__cards',{'see-all':seeAll}]">
				<template v-for="(item,i) in results" :key="`org-collection_${i}`">
					<div class="organisation-collection__card">
						<a :href="`/search/collection/${item.slug}`">
							<div class="organisation-collection__card-img">
								<img :src="calculated_img(item,i)" :alt="item.title" loading="lazy" onerror="this.onerror=null; this.src='/images/fallback.png'">
							</div>
							<div class="organisation-collection__card-body">
								<h5 class="organisation-collection__card-body__title" v-html="item.title"></h5>
							</div>
						</a>
					</div>
				</template>
			</div>

			<button class="btn btn-blue-dark btn-full" @click="doSeeAll">{{ seeAllText }}</button>

		</div>
	</section>
</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'collections-dev' : 'collections-live',
				searchObject: {
					hitsPerPage: 4,
					facets: ["type","publishied"],
					facetFilters: [["type:organisation"],["publishied:true"]]
				},
				results: false,
				seeAll: false,
				seeAllText: 'See more'
			}
		},

		methods: {
			calculated_img(item,index) {
				if (item.image !== "") {
					return this.$filters.analyseImage(item.image,'logosm','logoxl');
				}
				return '/images/collections/collection-icon-'+(index+1)+'.svg?'+this.$config.version;
			},
			doSeeAll() {
				this.seeAll = !this.seeAll;
				this.seeAllText = this.seeAll ? 'See less' : 'See more';
			}
		},

		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);


			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("organisation collection search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		}
	}
</script>
